export const LOADING_SYSTEM_CONFIGURATION_DATA =
  "LOADING_SYSTEM_CONFIGURATION_DATA";
export const SUCCESS_SYSTEM_CONFIGURATION_DATA =
  "SUCCESS_SYSTEM_CONFIGURATION_DATA";
